import { CookieUtils } from './cookie-utils';

export class Polymorph {
  private static defaultLocation = 'live';
  public static GetLoginApiLocation(): string {
    // cookie polymorph-az-login-api should change that it uses the local (DnnUser) controller from the current app
    const locationCookieValue = CookieUtils.getCookie('polymorph-az-login-api');
    return (!locationCookieValue) ? Polymorph.defaultLocation : locationCookieValue;
  }

  public static GetApiCatLocation(): string {
    // cookie polymorph-az-login-api-cat should change that it uses the staging/live "Me" controller from the catalog app
    const locationCookieValue = CookieUtils.getCookie('polymorph-az-login-api-cat');
    return (!locationCookieValue) ? Polymorph.defaultLocation : locationCookieValue;
  }
}
